/* import __COLOCATED_TEMPLATE__ from './company-project-module.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import clsx from 'clsx';

const CHART_COLORS = ['#6E6E6E', '#42D9BE', '#CDD91C'];
const CLASS_NAME = 'SH-c-company-project-module';

class CompanyProjectModule extends Component {
  @service media;

  get className() {
    return CLASS_NAME;
  }

  get chartLegendClassNames() {
    return clsx(
      `${this.className}__chart-legend`,
      this.isDesktopCompressed && `${this.className}__chart-legend--compressed`,
    );
  }

  get isDesktopCompressed() {
    return this.media.largeAndUp && this.media.dashboardLargeAndUpCompressedBound;
  }

  get showDefaultState() {
    return !this.args.companyProjectStats?.completed && !this.args.companyProjectStats?.inProgress;
  }

  get chartColors() {
    return CHART_COLORS;
  }

  get chartLegendType() {
    return (this.isDesktopCompressed) ?
      'tertiary'
      : 'secondary';
  }

  get chartLegendColors() {
    return (this.isDesktopCompressed) ?
      this.chartColors
      : ['#B1B1B1', '#30F1C7', '#D2DE1D'];
  }
}

export default CompanyProjectModule;
